/* V136 — VIENINTELIS atsiliepimų SKAIČIŲ šaltinis visoje svetainėje.
 *
 * Taisyklė (patvirtinta savininko):
 *   konkretaus produkto skaičius = Google įrašai su šiuo handle + žmonių suvesti su šiuo handle
 *   bendras skaičius             = visi Google įrašai + visi žmonių suvesti
 *
 * VIDURKIO NERODOME. Duomenyse kiekvienas įvertinimas pažymėtas
 * „REDAKCINIS — priskirta pagal teksto sentimentą; NE originalus Google rating".
 *
 * Iki v135 skaičiai buvo ranka įrašyti trijose vietose (72, 101, 132/98) ir nė
 * vienas nesutapo su duomenimis. Dabar Liquid išveda tik atsarginį skaičių,
 * o šis failas jį perskaičiuoja.
 *
 * Užpildo:
 *   [data-rating-for]  — product-review-meta eilutė; rodoma tik nuo MIN (3)
 *   [data-rc]          — bet kuris skaičius: data-rc-scope="product|all",
 *                        data-rc-handle, data-rc-text (tik su tekstu),
 *                        data-rc-forms="vns|dgs|kilm" (tada išvedama „N žodis")
 */
(function () {
  'use strict';
  var MIN = 3;
  var html = document.documentElement;
  var jsonUrl = html.getAttribute('data-reviews-json');
  var api = String(html.getAttribute('data-player-reviews-api') || '').replace(/\/+$/, '');
  if (!jsonUrl) return;
  if (!document.querySelector('[data-rating-for],[data-rc]')) return;

  /* Ta pati senųjų pavadinimų -> handle lentelė kaip mz-reviews.js normalize(). */
  var LEGACY = {
    'MUZIKINIS ŽAIDIMAS - PIRMA DALIS': 'muzikinis-zaidimas',
    'MUZIKINIS ŽAIDIMAS - AGATA': 'muzikinis-zaidimas-x-agata',
    'MUZIKINIS ŽAIDIMAS - KERNAGIS': 'muzikinis-zaidimas-x-kernagis',
    'MUZIKINIS ŽAIDIMAS': 'muzikinis-zaidimas',
    'MUZIKINIS ŽAIDIMAS x AGATA': 'muzikinis-zaidimas-x-agata',
    'MUZIKINIS | KERNAGIO LEIDIMAS': 'muzikinis-zaidimas-x-kernagis',
    'MUZIKINIS ŽAIDIMAS - PIRMA DALIS - PIRMA DALIS': 'muzikinis-zaidimas',
    'BALTOS KALĖDOS': 'baltos-kaledos',
    'PO DUTŪKSTANTŲJŲ': 'po-dutukstantuju',
    'PAKLAUSOM IŠ NAUJO': 'paklausom-is-naujo',
    'MŪSŲ DIENOS, KAIP ŠVENTĖ': 'musu-dienos-kaip-svente'
  };

  function plural(n, forms) {
    var f = String(forms || '').split('|');
    if (f.length !== 3) return '';
    var m10 = n % 10, m100 = n % 100;
    if (m10 === 1 && m100 !== 11) return f[0];
    if (m10 >= 2 && m10 <= 9 && !(m100 >= 11 && m100 <= 19)) return f[1];
    return f[2];
  }
  function bump(o, k) { o[k] = (o[k] || 0) + 1; }

  var google = fetch(jsonUrl, { credentials: 'same-origin' })
    .then(function (r) { return r.ok ? r.json() : null; })
    .catch(function () { return null; });
  var people = api
    ? fetch(api + '/reviews?limit=200&offset=0&sort=new')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) { return d && Array.isArray(d.reviews) ? d.reviews : []; })
        .catch(function () { return []; })
    : Promise.resolve([]);

  Promise.all([google, people]).then(function (res) {
    var g = res[0], p = res[1] || [];
    if (!g || !Array.isArray(g.reviews)) return;   /* paliekam atsarginius skaičius */

    var C = { all: 0, allText: 0, by: {}, byText: {}, scoreSum: {}, scoreN: {} };
    g.reviews.forEach(function (r) {
      var h = LEGACY[r.h] || r.h || '';
      var hasText = !!String(r.t || '').trim();
      C.all++; if (hasText) C.allText++;
      if (h) { bump(C.by, h); if (hasText) bump(C.byText, h); }
    });
    p.forEach(function (r) {
      /* V138: bandomasis atsiliepimas neįskaičiuojamas į viešą skaičių. */
      if (String(r.author || '').trim().toLowerCase() === 'justas' &&
          String(r.body || '').trim().toLowerCase() === 'testas testas' &&
          r.product === 'muzikinis-zaidimas-x-kernagis' &&
          String(r.created_at || '').slice(0, 10) === '2026-09-22') return;
      var h = r.product || '';
      /* Vertinimą skaičiuojame TIK iš autentiškų naujų atsiliepimų.
         Editorial Google sentiment labels nenaudojamos kaip žvaigždutės. */
      var score = Number(r.rating);
      if (h && Number.isFinite(score) && score >= 1 && score <= 5 && Math.floor(score) === score) {
        C.scoreSum[h] = (C.scoreSum[h] || 0) + score;
        C.scoreN[h] = (C.scoreN[h] || 0) + 1;
      }
      var hasText = !!String(r.body || '').trim();
      C.all++; if (hasText) C.allText++;
      if (h) { bump(C.by, h); if (hasText) bump(C.byText, h); }
    });

    function count(scope, handle, textOnly) {
      if (scope === 'all') return textOnly ? C.allText : C.all;
      return (textOnly ? C.byText[handle] : C.by[handle]) || 0;
    }

    document.querySelectorAll('[data-rc]').forEach(function (el) {
      var scope = el.getAttribute('data-rc-scope') === 'product' ? 'product' : 'all';
      var n = count(scope, el.getAttribute('data-rc-handle') || '', el.hasAttribute('data-rc-text'));
      var forms = el.getAttribute('data-rc-forms');
      el.textContent = forms ? (n + ' ' + plural(n, forms)) : String(n);
    });

    document.querySelectorAll('[data-rating-for]').forEach(function (el) {
      var handle = el.getAttribute('data-rating-for');
      var n = count('product', handle, false);
      var starWrap = el.querySelector('[data-rating-stars]');
      if (starWrap) {
        var verified = C.scoreN[handle] || 0;
        var avg = verified ? C.scoreSum[handle] / verified : 0;
        starWrap.style.setProperty('--mz-rating-percent', (avg / 5 * 100) + '%');
        starWrap.setAttribute('aria-label', verified ? ('Svetainės žaidėjų įvertinimas ' + avg.toFixed(1).replace('.', ',') + ' iš 5, ' + verified + ' įvertinimai') : 'Atsiliepimų ženklas, ne vidutinis įvertinimas');
      }
      var row = el.querySelector('[data-rating-row]');
      if (!row) return;
      var nn = el.querySelector('[data-rating-count]');
      var ww = el.querySelector('[data-rating-word]');
      if (nn) nn.textContent = String(n);
      if (ww) ww.textContent = plural(n, 'atsiliepimas|atsiliepimai|atsiliepimų');
      row.hidden = false;
    });
  });
})();
